import type { CatalogoResponse, ItemAdicionarComanda, ProdutoCatalogo } from '@/api'
import { temPassos } from '@/components/catalogo-kiosk/passos'
import { precoPorQuantidade } from '@/lib/preco-por-quantidade'

/** Só o ENCONTRADO vira item; o resto diz à tela por que o produto lido não entrou. */
export type ResultadoCodigoBarras =
  | { status: 'ENCONTRADO'; produto: ProdutoCatalogo }
  | { status: 'NAO_ENCONTRADO' }
  | { status: 'DUPLICADO' }
  | { status: 'COM_OPCOES'; produto: ProdutoCatalogo }
  | { status: 'PESAVEL'; produto: ProdutoCatalogo }
  | { status: 'ETIQUETA_BALANCA' }

// Etiqueta de balança (prefixo 2, EAN-13) traz peso ou preço embutido: no autoatendimento fica de fora.
const ETIQUETA_BALANCA = /^2\d{12}$/

/** Procura o código lido no catálogo do totem, como o PDV: pelo `codigo_barras`, comparado inteiro. */
export function resolverProdutoPorCodigo(catalogo: CatalogoResponse, leitura: string): ResultadoCodigoBarras {
  const codigo = leitura.trim()
  if (!codigo) return { status: 'NAO_ENCONTRADO' }

  const achados = new Map<number, ProdutoCatalogo>()
  for (const grupo of catalogo.grupos) {
    for (const produto of grupo.produtos) {
      if (produto.codigoBarras === codigo) achados.set(produto.id, produto)
    }
  }

  if (achados.size > 1) return { status: 'DUPLICADO' }

  const [produto] = achados.values()
  if (!produto) return ETIQUETA_BALANCA.test(codigo) ? { status: 'ETIQUETA_BALANCA' } : { status: 'NAO_ENCONTRADO' }
  if (temPassos(produto)) return { status: 'COM_OPCOES', produto }
  if (produto.pesavel) return { status: 'PESAVEL', produto }

  return { status: 'ENCONTRADO', produto }
}

/** Uma unidade do produto lido, no mesmo formato do item simples do "Adicionar item". */
export function itemDoCodigoBarras(produto: ProdutoCatalogo): ItemAdicionarComanda {
  const valorUnitario = precoPorQuantidade(produto.faixasPreco, 1, produto.valor)

  return { idProduto: produto.id, nome: produto.descricao, quantidade: 1, valorUnitario, valorTotal: valorUnitario }
}
